import Div from '@/shared/Div';
import React, { memo } from 'react';
import PercentageIcon from '../Icons/Percentage';

const Title = ({ title, subTitle, savingText }: any) => {
  return (
    <Div className="flex flex-col gap-s5 text-center">
      <Div
        className=" text-h-1 text-black/70 md:text-desktop-display font-primary"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <Div
        className="text-body-lg text-black/70 md:text-body-xl font-primary md:max-w-lg mx-auto"
        dangerouslySetInnerHTML={{ __html: subTitle }}
      />
      <Div className="border border-green-500 p-3 flex gap-s3 bg-green-100 rounded-cs items-center  sm:w-fit sm:self-center mx-auto w-fit">
        <PercentageIcon />
        <Div
          className="text-body-lg text-black/70 font-primary"
          dangerouslySetInnerHTML={{ __html: savingText }}
        />
      </Div>
    </Div>
  );
};

export default memo(Title);
